import { useAppContext } from '../../AppContext';

export type Subsidiary = 'nl' | 'be' | 'de';

export const useSubsidiary = (): Subsidiary => {
  const { agent } = useAppContext();
  const username = agent?.getConfiguration()?.username ?? '';
  const domain = username.slice(-2).toLowerCase();
  if (domain === 'be' || domain === 'de') return domain;
  return 'nl';
};
